import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M13.262 5.02c0-.492.4-.891.891-.891h4.456c.492 0 .891.399.891.891v4.455a.891.891 0 0 1-1.782 0V7.171l-5.162 5.162a.891.891 0 1 1-1.26-1.26l5.162-5.162h-2.305a.89.89 0 0 1-.89-.891M5.715 6.505h4.86v1.823H6.324v9.72h9.72v-4.252h1.823v4.86c0 .671-.544 1.215-1.215 1.215H5.715A1.215 1.215 0 0 1 4.5 18.656V7.72c0-.671.544-1.215 1.215-1.215",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-hyperlink"}) } }